import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-24" data-id="element-414" data-mp="2o1lrlvn7yv55">
      <section className="border-b border-white/10 py-16 sm:py-24" data-id="element-415" data-mp="2s0tf9orr8rfp">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-416" data-mp="2x060y66w3sgp">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end" data-id="element-417" data-mp="2x1h4c4wfay7a">
            <div className="max-w-3xl" data-id="element-418" data-mp="3fq5q0t2qd7k4">
              <p className="eyebrow" data-id="element-419" data-mp="3kps4t6y7ivv1">Información legal</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-420" data-mp="3krbjwu84n0v8">
                Política de Privacidad
              </h1>
            </div>
            <p className="border-l border-white/10 pl-5 text-xs leading-relaxed text-neutral-500 lg:max-w-[185px]" data-id="element-421" data-mp="2yrg8aa1exksv">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-422" data-mp="3hgv7dyxjfzum">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-423" data-mp="3hg3b0lw49y3a">
          <motion.article initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="mx-auto max-w-3xl border-x border-t border-white/10" aria-label="Contenido de la política de privacidad" data-id="element-424" data-mp="3dgcfy5zk4vsy">
            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-425" data-mp="j4qad0f9m3q1">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-426" data-mp="o3te8hjie3wf">
                1. Responsable del tratamiento
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-427" data-mp="ac6gsedtypc2">
                Growthly LLC es el responsable del tratamiento de los datos
                personales del Usuario y le informa que estos datos serán
                tratados de conformidad con lo dispuesto en el Reglamento (UE)
                2016/679 de 27 de abril de 2016 (GDPR) y la Ley Orgánica 3/2018
                de 5 de diciembre (LOPDGDD).
              </p>
              <ul className="mt-5 space-y-2 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-428" data-mp="3rk1mtwgozwom">
                <li data-id="element-429" data-mp="1lscz805x9yjq">
                  <strong className="font-medium text-neutral-200" data-id="element-430" data-mp="1lpqwqexw298d">
                    Identidad:
                  </strong>{' '}
                  Growthly LLC
                </li>
                <li data-id="element-431" data-mp="3abqymgddnmn6">
                  <strong className="font-medium text-neutral-200" data-id="element-432" data-mp="3a94pwder313d">
                    Teléfono:
                  </strong>{' '}
                  +34 631 01 25 92
                </li>
                <li data-id="element-433" data-mp="3k3dh8xs1onzy">
                  <strong className="font-medium text-neutral-200" data-id="element-434" data-mp="3fakegfg4zpqi">
                    Correo electrónico:
                  </strong>{' '}
                  hola@growthly.com
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-435" data-mp="3ozc065ultdsz">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-436" data-mp="6v0njn2xujem">
                2. Datos que recogemos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-437" data-mp="1wgznh4saxjm">
                Recopilamos los datos estrictamente necesarios para el correcto
                desarrollo de nuestra actividad y la prestación de nuestros
                servicios. Estos datos incluyen:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-438" data-mp="263s5er9ool9i">
                <li data-id="element-439" data-mp="2f1vs3qweno2w">Datos identificativos: nombre y apellidos.</li>
                <li data-id="element-440" data-mp="2f0b0a91h6j8q">
                  Datos de contacto: dirección de correo electrónico y número de
                  teléfono.
                </li>
                <li data-id="element-441" data-mp="1merif8mdalks">
                  Datos de navegación: dirección IP, comportamiento en la web
                  (mediante cookies).
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-442" data-mp="1wbmihvyagu16">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-443" data-mp="2134e04hjm2er">
                3. Finalidad del tratamiento
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-444" data-mp="13myq7gf4h4e4">
                Los datos personales proporcionados serán utilizados para las
                siguientes finalidades:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-445" data-mp="w3prch48so3b">
                <li data-id="element-446" data-mp="r3tmkfnq0smp">
                  Gestionar la contratación de nuestros servicios de diseño y
                  desarrollo web.
                </li>
                <li data-id="element-447" data-mp="m7w5g74mvi8v">
                  Responder a consultas, solicitudes o peticiones realizadas a
                  través de los canales de contacto.
                </li>
                <li data-id="element-448" data-mp="dbn9j2fv71rh">
                  Enviar comunicaciones comerciales sobre nuestros servicios
                  (solo si se ha dado el consentimiento expreso).
                </li>
                <li data-id="element-449" data-mp="3gd382ifo87w">
                  Mejorar la experiencia de usuario en nuestra página web.
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-450" data-mp="3qk00i5dl6s94">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-451" data-mp="3fymjzq7pe21y">
                4. Base legal
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-452" data-mp="3kxzhd4w7aris">
                La base legal para el tratamiento de sus datos es la ejecución
                de un contrato (en caso de contratación de servicios), el
                consentimiento del interesado (para el envío de comunicaciones
                comerciales y el uso de cookies no técnicas) y el interés
                legítimo (para responder a consultas y mejorar nuestra web).
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-453" data-mp="3pvrbm5kbipq5">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-454" data-mp="3uv3tsd08v8me">
                5. Conservación de los datos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-455" data-mp="me0nrxd4lxab">
                Los datos se conservarán durante el tiempo necesario para
                cumplir con la finalidad para la que se recabaron y para
                determinar las posibles responsabilidades que se pudieran
                derivar de dicha finalidad y del tratamiento de los datos,
                además de los periodos establecidos en la normativa de archivos
                y documentación.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-456" data-mp="hm87hy20hh5x">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-457" data-mp="dlfuqutxku4w">
                6. Derechos del usuario
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-458" data-mp="rlqms16z8ern">
                Como usuario, tiene derecho a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-459" data-mp="22zufl41tvwv4">
                <li data-id="element-460" data-mp="1xzydxbglshiq">Acceder a sus datos personales.</li>
                <li data-id="element-461" data-mp="3sh86iouou78h">Solicitar la rectificación de los datos inexactos.</li>
                <li data-id="element-462" data-mp="3sj2obuanxj8c">
                  Solicitar su supresión cuando, entre otros motivos, los datos
                  ya no sean necesarios para los fines que fueron recogidos.
                </li>
                <li data-id="element-463" data-mp="5b7c87lao0x2">Solicitar la limitación del tratamiento de sus datos.</li>
                <li data-id="element-464" data-mp="a40hcwkodb9o">Oponerse al tratamiento de sus datos.</li>
                <li data-id="element-465" data-mp="f2v1c1udp5vd">Solicitar la portabilidad de sus datos.</li>
              </ul>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-466" data-mp="k1emw1528fn7">
                Puede ejercer estos derechos enviando un correo electrónico a
                hola@growthly.com.
              </p>
            </section>

            <section className="px-6 py-8 sm:px-10 sm:py-10" data-id="element-467" data-mp="t11nwltvnjfq">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-468" data-mp="2pumqdmxkqmtc">
                7. Política de Cookies
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-469" data-mp="2uu96c44seh5u">
                Esta página web utiliza cookies técnicas necesarias para su
                funcionamiento. También podemos utilizar cookies analíticas para
                entender cómo los usuarios interactúan con el sitio web. Puede
                configurar su navegador para rechazar todas las cookies o para
                que le avise cuando se envíe una cookie.
              </p>
            </section>
          </motion.article>
        </div>
      </section>
    </div>;
}